import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context';
import { TypeUser } from '../types/enums';

const AuthAdm: ({ children }: { children: React.ReactNode }) => any = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { tokenIsValid, user } = useAuth();
  const location = useLocation();

  if (!tokenIsValid) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if(user.type !== TypeUser.ADM){
    return <Navigate to="/feed" replace />
  }
  return (
    <div>
      {children}
    </div>
  );
};

export default AuthAdm;
